import React, { useState, useEffect } from 'react';
import { publicApi } from '../../services/api';
import { flattenSettings, getThemeColors } from '../../utils/settings';

/**
 * Reusable PageHeader — gradient header konsisten di semua halaman publik.
 * Warna diambil dari settings (primary_color + secondary_color).
 *
 * Props:
 *   title    - string (wajib)
 *   subtitle - string (opsional)
 */
export default function PageHeader({ title, subtitle }) {
  const [colors, setColors] = useState({ primary: '#081626', secondary: '#00CFFF' });

  useEffect(() => {
    publicApi.getSettings()
      .then(res => {
        const groups = res.data?.data || {};
        const flat = flattenSettings(groups);
        const theme = getThemeColors(flat);
        setColors(theme);
      })
      .catch(() => {});
  }, []);

  return (
    <section
      className="pt-32 pb-20 text-center text-white"
      style={{ background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.secondary} 100%)` }}
    >
      <div className="max-w-4xl mx-auto px-4">
        <h1
          className="text-4xl sm:text-5xl font-extrabold mb-4"
          style={{ fontFamily: "'Cabin', sans-serif" }}
        >
          {title}
        </h1>
        {subtitle && (
          <p className="text-lg" style={{ color: 'rgba(255,255,255,0.85)' }}>
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
}